(function () {
  'use strict';

  var KEYS = ['certificates', 'bundles', 'services', 'membership'];

  function getData(key) {
    var el = document.getElementById('dex-mega-' + key + '-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateHeaderHeight(nav) {
    document.documentElement.style.setProperty('--header-height', nav.offsetHeight + 'px');
  }

  function buildRail(tabs, railEl, activeKey) {
    var html = '';
    tabs.forEach(function (tab) {
      html += '<button class="dex-rail-filter' + (tab.key === activeKey ? ' is-active' : '') +
        '" data-key="' + esc(tab.key) + '">' +
        '<span class="dex-rail-label">' + esc(tab.railLabel) + '</span>' +
        '<span>' + esc(tab.railCount) + '</span>' +
        '</button>';
    });
    railEl.innerHTML = html;
  }

  function renderCenter(centerEl, tab) {
    var html = '';

    html += '<div class="dex-mega-center-head"><div>';
    if (tab.tabHeading) html += '<h2>' + esc(tab.tabHeading) + '</h2>';
    if (tab.tabIntro) html += '<p>' + esc(tab.tabIntro) + '</p>';
    html += '</div>';
    if (tab.viewAllLabel && tab.viewAllUrl) {
      html += '<a href="' + esc(tab.viewAllUrl) + '">' + esc(tab.viewAllLabel) + '</a>';
    }
    html += '</div>';

    var visible = (tab.cards || []).filter(function (c) { return c.show; });
    if (visible.length) {
      html += '<div class="dex-mega-card-grid">';
      visible.forEach(function (card) {
        var isLink = card.link && card.link.show && card.link.url;
        var tag = isLink ? 'a' : 'div';
        var href = isLink ? ' href="' + esc(card.link.url) + '"' : '';
        html += '<' + tag + ' class="dex-cert-card"' + href + '>';
        html += '<div class="dex-cert-art">';
        if (card.image && card.image.show && card.image.url) {
          html += '<img src="' + esc(card.image.url) + '" alt="' + esc(card.image.alt || '') + '" loading="lazy">';
        }
        if (card.badge && card.badge.show && card.badge.text) {
          html += '<span class="dex-cert-code">' + esc(card.badge.text) + '</span>';
        }
        html += '</div><div class="dex-cert-body">';
        if (card.title && card.title.show && card.title.text) {
          html += '<h3>' + esc(card.title.text) + '</h3>';
        }
        if (card.detail && card.detail.show && card.detail.text) {
          html += '<p>' + esc(card.detail.text) + '</p>';
        }
        if (card.meta && card.meta.show && card.meta.text) {
          html += '<span class="dex-cert-price">' + esc(card.meta.text) + '</span>';
        }
        html += '</div></' + tag + '>';
      });
      html += '</div>';
    }

    var links = tab.links;
    if (links && links.items && links.items.length) {
      var vis = links.items.filter(function (l) { return l.show; });
      if (vis.length) {
        html += '<div class="dex-mega-links"><div class="dex-mega-link-group">';
        if (links.heading) html += '<h3>' + esc(links.heading) + '</h3>';
        vis.forEach(function (l) {
          html += '<a href="' + esc(l.url || '#') + '">' + esc(l.label) + '</a>';
        });
        html += '</div></div>';
      }
    }

    centerEl.innerHTML = html;
  }

  function renderPromo(promoEl, tab) {
    var p = tab.promo || {};
    promoEl.setAttribute('data-promo', tab.key);
    promoEl.style.setProperty('--dex-promo-overlay-opacity', p.overlayOpacity != null ? p.overlayOpacity : 45);
    if (p.headingColor) promoEl.style.setProperty('--dex-promo-heading-color', p.headingColor);
    if (p.bodyColor) promoEl.style.setProperty('--dex-promo-body-color', p.bodyColor);

    var html = '';
    if (p.backgroundImage) {
      html += '<img class="dex-promo-bg" src="' + esc(p.backgroundImage) + '" alt="" loading="lazy">';
      promoEl.classList.add('has-promo-image');
    } else {
      promoEl.classList.remove('has-promo-image');
    }

    html += '<div class="dex-promo-copy">';
    if (p.heading) html += '<h2>' + esc(p.heading) + '</h2>';
    if (p.body) html += '<p>' + esc(p.body) + '</p>';
    html += '</div>';

    if (p.show !== false) {
      var hasPrimary = p.showPrimary && p.primaryLabel;
      var hasSecondary = p.showSecondary && p.secondaryLabel;
      if (hasPrimary || hasSecondary) {
        html += '<div class="dex-promo-actions">';
        if (hasPrimary) {
          html += '<a href="' + esc(p.primaryUrl || '#') + '" class="dex-btn dex-btn-primary">' + esc(p.primaryLabel) + '</a>';
        }
        if (hasSecondary) {
          html += '<a href="' + esc(p.secondaryUrl || '#') + '" class="dex-btn dex-btn-secondary">' + esc(p.secondaryLabel) + '</a>';
        }
        html += '</div>';
      }
    }

    promoEl.innerHTML = html;
  }

  function buildMobileDropdown(tabs, dropdownEl) {
    var html = '';
    tabs.forEach(function (tab) {
      var links = tab.links;
      if (!links || !links.items || !links.items.length) return;
      var vis = links.items.filter(function (l) { return l.show; });
      if (!vis.length) return;
      html += '<div class="dex-mobile-group">';
      if (links.heading) html += '<h3>' + esc(links.heading) + '</h3>';
      vis.forEach(function (l) {
        html += '<a href="' + esc(l.url || '#') + '">' + esc(l.label) + '</a>';
      });
      html += '</div>';
    });
    dropdownEl.innerHTML = html;
  }

  function findTab(tabs, key) {
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].key === key) return tabs[i];
    }
    return null;
  }

  function init() {
    var nav = document.querySelector('.dex-nav-v2');
    if (!nav) return;

    var tabs = KEYS.map(getData).filter(Boolean);
    if (!tabs.length) return;

    var railEl = nav.querySelector('[data-dex-rail]');
    var centerEl = nav.querySelector('[data-dex-center]');
    var promoEl = nav.querySelector('[data-dex-promo]');
    var mobileDropdownEl = nav.querySelector('[data-dex-mobile-dropdown]');

    var activeKey = tabs[0].key;

    if (railEl) buildRail(tabs, railEl, activeKey);
    if (centerEl) renderCenter(centerEl, tabs[0]);
    if (promoEl) renderPromo(promoEl, tabs[0]);
    if (mobileDropdownEl) buildMobileDropdown(tabs, mobileDropdownEl);

    if (railEl) {
      var hoverTimer = null;
      var lastHoverKey = null;
      var activateKey = function (key) {
        var tab = findTab(tabs, key);
        if (!tab) return;
        activeKey = key;
        railEl.querySelectorAll('.dex-rail-filter').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-key') === key);
        });
        if (centerEl) renderCenter(centerEl, tab);
        if (promoEl) renderPromo(promoEl, tab);
      };
      railEl.addEventListener('mouseover', function (e) {
        var btn = e.target.closest('[data-key]');
        if (!btn) return;
        var k = btn.getAttribute('data-key');
        if (k === lastHoverKey) return;
        lastHoverKey = k;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { activateKey(k); }, 120);
      });
      railEl.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        lastHoverKey = null;
      });
      railEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-key]');
        if (!btn) return;
        clearTimeout(hoverTimer);
        lastHoverKey = null;
        activateKey(btn.getAttribute('data-key'));
      });
    }

    var mobileToggle = nav.querySelector('[data-dex-mobile-toggle]');
    var mobilePanel = nav.querySelector('.dex-mobile-panel');
    if (mobileToggle && mobilePanel) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = mobilePanel.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
        updateHeaderHeight(nav);
      });
    }

    var solutionsToggle = nav.querySelector('[data-dex-solutions-toggle]');
    var mobileDropdownDiv = nav.querySelector('.dex-mobile-dropdown');
    if (solutionsToggle && mobileDropdownDiv) {
      solutionsToggle.addEventListener('click', function () {
        var isOpen = mobileDropdownDiv.classList.toggle('is-open');
        solutionsToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    function onScroll() {
      nav.classList.toggle('is-scrolled', window.scrollY > 4);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    updateHeaderHeight(nav);
    window.addEventListener('resize', function () { updateHeaderHeight(nav); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
